module.exports = __webpack_public_path__ + "img/Icon - View More.f722cc01.svg";